import { ElementType } from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { RouteInfoType } from './types';

export const Routes = (
  Layout: ElementType,
  routes: Array<RouteInfoType>,
  linkedPatientCount: number
) => {
  const componentAndChildRoutes = routes.map(({ component: Component, children, path, id }) => {
    const appRoutes: JSX.Element[] = [];
    if (Component) {
      appRoutes.push(
        <Route
          key={id}
          path={path}
          exact
          render={(props) => (
            <Layout>
              <Component {...props} />
            </Layout>
          )}
        />
      );
    }
    if (children) {
      children.map(({ path: childPath, component: ChildComponent }) =>
        appRoutes.push(
          <Route
            key={childPath}
            path={childPath}
            exact
            render={
              ChildComponent === null
                ? undefined
                : (props: RouteComponentProps) => (
                    <Layout>
                      <ChildComponent {...props} />
                    </Layout>
                  )
            }
          />
        )
      );
    }

    return appRoutes;
  });
  return [
    <Redirect
      key="redirect"
      exact
      from="/"
      to={linkedPatientCount === 0 ? '/programs' : '/linked-patients'}
    />,
    ...componentAndChildRoutes,
  ];
};
